export function getDesktopNotificationHost() {
  let host = document.getElementById("desktop-notification-viewport");
  if (!host) {
    host = document.createElement("div");
    host.id = "desktop-notification-viewport";
    host.setAttribute("popover", "manual");
    host.setAttribute("aria-label", "Notifications");
    (document.fullscreenElement || document.body).appendChild(host);
    document.addEventListener("fullscreenchange", () => {
      (document.fullscreenElement || document.body).appendChild(host);
      if (host.childElementCount) host.showPopover?.();
    });
  }
  return host;
}
